import HalftoneIceCreamImage from 'assets/images/icecream-fallen.png';

export const ERROR_ACTION = {
  SHOW_LOGOUT_ERROR: 'SHOW_LOGOUT_ERROR',
  SHOW_UNAUTHORIZED_ERROR: 'SHOW_UNAUTHORIZED_ERROR',
  SHOW_ERROR_MODAL: 'SHOW_ERROR_MODAL',
};

export const DEFAULT_ERROR_STATE = {
  hasError: false,
  errorDetails: {},
  errorAction: '',
  errorCallback: null,
};

// Error + Error Button Types
export const UNAUTHORIZED = 'unauthorized';
export const CONTACT_SUPPORT = 'contactSupport';

export const ERROR_PAGE_TITLES = {
  notFound: 'this page is 86’d',
  general: 'oops',
  unauthorized: 'no access',
};

export const ERROR_PAGE_SUBTITLES = {
  notFound:
    'Your URL might be wrong or it might not exist anymore. Try again or click the link below.',
  general: 'Something went wrong. Try to refresh the page or click the link below.',
  generalWithoutLink: 'Something went wrong. Try to refresh the page.',
  unauthorized:
    'You do not have access to this content. If you believe you’ve reached this page by mistake, contact support.',
  locationUnauthorized:
    'This restaurant location does not have access to this content. Please select another location or contact support.',
  noAccessSimple: "You don't have access to this location.",
  cuboh403: 'Your session has expired. Please sign out and sign back in to continue.',
};

export const ERROR_MODAL_DEFAULTS = {
  title: 'Something went wrong',
  confirmLabel: 'Return to Dashboard',
  message: 'An error occurred. Please refresh to try again.',
};

export const ERROR_PAGE_BUTTONS = {
  backToHq: 'Back to Headquarters',
  goToLogin: 'Go to Login',
  logout: 'Log Out',
  goToOverview: 'Go to Overview',
  contactSupport: 'Contact Support',
  startExploring: 'Start Exploring',
};

export const ERROR_PAGE_IMAGES = {
  unauthorized: HalftoneIceCreamImage,
  general: HalftoneIceCreamImage,
  notFound: HalftoneIceCreamImage,
};

export const ERROR_CODES = {
  googleBusinessProfileScopeError: '80002',
  googleBusinessProfileWrongCredentials: '80003',
  invalidLogin: '20099',
  invalidVerificationCode: '20104',
  refundType: '53001',
  requiredFieldMissing: '10101',
  signalAborted: 20,
};

export const REDISPATCH_ERROR_CODES = [
  '57001', // DMS_REDISPATCH_FAILURE
  '57002', // DMS_REDISPATCH_ORDER_NOT_FOUND
  '57003', // DMS_REDISPATCH_IN_PROGRESS
];

export const GENERIC_QUERY_ERROR_MESSAGE = 'Oops! There was an issue loading your data.';
